import { VStack } from '@starrez/starryui9';
import React, { FC } from 'react';
import styled from 'styled-components';
import { LabelledControl } from './LabelledControl';
import { Variant } from './types';
import { ValidationError } from './ValidationError';

export interface IValidatedControlProps {
    invalid?: boolean;
    children: (props: { invalid?: boolean; disabled?: boolean; id: string }) => React.ReactNode;
    variant: Variant;
    caption: string;
    validationMessage: string;
    disabled?: boolean;
    id: string;
}

export const ValidatedControl: FC<IValidatedControlProps> = ({ id, children, invalid, variant, caption, validationMessage, disabled }) => {
    return (
        <VStack gap="xxSmall">
            <LabelledControl variant={variant} caption={caption} htmlFor={id}>
                {children({ invalid, disabled, id })}
            </LabelledControl>
            <StyledValidation variant={variant}>{invalid && <ValidationError id="">{validationMessage}</ValidationError>}</StyledValidation>
        </VStack>
    );
};

const StyledValidation = styled.div<{ variant: Variant }>`
    min-height: 20px;
    ${(props) => (props.variant === 'Rows' ? `padding-left: 0;` : props.variant === 'Columns' ? `padding-left: 165px;` : `padding-left: 85px;`)}
`;
